import React, { Fragment, useState } from 'react'
import { Button } from '../ui/button';
import placeholder from "../../util/placeholder";
import CustomCollapsible from '../CustomCollapsible';
import { OrdersType } from '../../shared/interfaces/requests.interface';

interface FleetOwnersProps {
  request: OrdersType
}

function FleetOwnersAssigned({request}: FleetOwnersProps) {
  return (
  <div className="flex flex-col gap-4 h-full">
    <div className="flex-1 flex flex-col gap-4 overflow-auto">
        {request.assignments.map((assignment, idx) => (
            <Fragment key={idx}>
                {assignment.vehicles.map((item, index) => (
                    <CustomCollapsible key={index} variant="primary">
                        <CustomCollapsible.Trigger>
                            <img src={request.truckCategory.image || placeholder} alt="Dump Truck" className="w-10 h-10 rounded object-cover" />
                            <div className="flex-1">
                                <div className="flex items-center justify-between">
                                    <span className="font-semibold text-[#1A237E] text-sm">
                                    {item?.vehicle?.trackingDeviceId} - {item?.vehicle?.regPlate}
                                    </span>
                                </div>
                                <div className="flex items-center justify-between text-[#90A4AE] text-xs">
                                    <span>{assignment?.fleetOwner?.companyName}</span>
                                    <span className="text-[#90A4AE] text-xs font-medium">  
                                        {item?.completedTrips}/{item?.noOfTrips}
                                    </span>
                                </div>
                            </div>
                        </CustomCollapsible.Trigger>
                        <CustomCollapsible.Content>
                            <div className="px-4 pb-6 pt-1 text-[13px] space-y-6">
                                <div className="text-[#1976D2] underline cursor-pointer mb-1">
                                    {assignment?.fleetOwner?.companyName}
                                </div>
                                <div className="mb-1 space-y-2">
                                    <span className="text-[#1A237E] font-medium">Vehicle name from Owner</span>
                                    <div className="text-[#F9A825] font-semibold text-sm">{item?.vehicle?.regPlate}</div>
                                    <div className="flex gap-2 items-center text-xs mt-1">
                                        <span className="text-[#1976D2] font-semibold">{item?.completedTrips}/{item?.noOfTrips}</span>
                                        <span className="text-[#90A4AE]">Trips Completed</span>
                                    </div>
                                </div>
                                <div className="mt-2 mb-1 space-y-2">
                                    <div className="font-semibold text-[#1A237E] text-xs mb-0.5">Driver Information</div>
                                    <div className="text-[#1976D2] font-medium">{item?.vehicle?.driverName}</div>
                                    <div className="text-[#90A4AE] text-xs">{item?.vehicle?.driverPhone}</div>
                                </div>
                                <div className="mt-2 space-y-2">
                                    <div className="font-semibold text-[#1A237E] text-xs mb-0.5">Location</div>
                                    <div className="text-[#90A4AE] text-xs mb-1">
                                        {item?.vehicle?.locationAvailable ? 'Location information available for this vehicle' : 'Location information not available for this vehicle'}
                                    </div>
                                    {item?.vehicle?.locationAvailable && (
                                        <div className="text-[#1976D2] underline cursor-pointer text-xs">View Location</div>
                                    )}
                                </div>
                            </div>
                        </CustomCollapsible.Content>
                    </CustomCollapsible>                                    
                ))}
            </Fragment>
        ))}
    </div>
    {/* <Button className="w-full bg-[#1976D2] text-white font-semibold py-2 rounded mt-2">Complete Rental</Button> */}
  </div>
  );
}

export default FleetOwnersAssigned